/**
 * Created by Dhanya Akhil on 1/30/2017.
 */
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HasAuthorityDirective} from '../services/has-authority.directive';
import {HasAnyAuthorityDirective} from '../services/has-any-authority.directive'


@NgModule({
  imports: [CommonModule],
  declarations: [
    HasAuthorityDirective,
    HasAnyAuthorityDirective
  ],
  exports: [HasAuthorityDirective, HasAnyAuthorityDirective]
})
export class SharedModule {
}
